import React, { useState, useEffect } from "react";
import { main_link } from "../Connection/Connection";
import useFetch from "../Fetch_Folder/useFetch";
import Spinner from "react-bootstrap/Spinner";
import "../my_styles/myStyles.css";

const Home = () => {
  const user = JSON.parse(sessionStorage.getItem("user-data"));
  const user_id = user["encrypted_id"];
  const [counter, setCounter] = useState(0);

  const {
    error,
    isLoading,
    data: metrics,
  } = useFetch(`${main_link}getMetrics?user_id=${user_id}`, counter);

  // console.table(metrics);
  return (
    <div>
      {/* Content Wrapper. Contains page content */}
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1>Home</h1>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        {/* Main content */}
        <section className="content">
          {/* Default box */}
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Dashboard</h3>
              <div className="card-tools">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="collapse"
                  title="Collapse"
                >
                  <i className="fas fa-minus" />
                </button>
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  title="Remove"
                >
                  <i className="fas fa-times" />
                </button>
              </div>
            </div>

            <div className="card-body">
              <div className="row">
                {/* Total Metrics Section */}
                <div className="col-md-4 col-12">
                  <div className="info-box info-box-hover shadow-lg rounded-lg">
                    <span className="info-box-icon bg-gradient-info text-white">
                      <i className="fas fa-calendar-alt"></i>
                    </span>
                    <div className="info-box-content">
                      <h6 className="info-box-text">Total Appointments</h6>
                      <span className="info-box-number">
                        {isLoading ? (
                          <Spinner size="sm" animation="border" role="status" />
                        ) : (
                          metrics?.totalAppointments
                        )}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Monthly Metrics Section */}
                <div className="col-md-4 col-12">
                  <div className="info-box info-box-hover shadow-lg rounded-lg">
                    <span className="info-box-icon bg-gradient-success text-white">
                      <i className="fas fa-cut"></i>
                    </span>
                    <div className="info-box-content">
                      <h6 className="info-box-text">Cuts This Month</h6>
                      <span className="info-box-number">
                        {isLoading ? (
                          <Spinner size="sm" animation="border" role="status" />
                        ) : (
                          metrics?.cutsThisMonth
                        )}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-4 col-12">
                  <div className="info-box info-box-hover shadow-lg rounded-lg">
                    <span className="info-box-icon bg-gradient-success text-white">
                      <i className="fas fa-calendar-check"></i>
                    </span>
                    <div className="info-box-content">
                      <h6 className="info-box-text">Appointments This Month</h6>
                      <span className="info-box-number">
                        {isLoading ? (
                          <Spinner size="sm" animation="border" role="status" />
                        ) : (
                          metrics?.appointmentsThisMonth
                        )}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Daily Metrics Section */}
                <div className="col-md-4 col-12">
                  <div className="info-box info-box-hover shadow-lg rounded-lg">
                    <span className="info-box-icon bg-gradient-warning text-white">
                      <i className="fas fa-cut"></i>
                    </span>
                    <div className="info-box-content">
                      <h6 className="info-box-text">Cuts Today</h6>
                      <span className="info-box-number">
                        {isLoading ? (
                          <Spinner size="sm" animation="border" role="status" />
                        ) : (
                          metrics?.cutsToday
                        )}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-4 col-12">
                  <div className="info-box info-box-hover shadow-lg rounded-lg">
                    <span className="info-box-icon bg-gradient-warning text-white">
                      <i className="fas fa-calendar"></i>
                    </span>
                    <div className="info-box-content">
                      <h6 className="info-box-text">Appointments Today</h6>
                      <span className="info-box-number">
                        {isLoading ? (
                          <Spinner size="sm" animation="border" role="status" />
                        ) : (
                          metrics?.appointmentsToday
                        )}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Customer Stats Section */}
                <div className="col-md-4 col-12">
                  <div className="info-box info-box-hover shadow-lg rounded-lg">
                    <span className="info-box-icon bg-gradient-primary text-white">
                      <i className="fas fa-user-plus"></i>
                    </span>
                    <div className="info-box-content">
                      <h6 className="info-box-text">
                        New Customers This Month
                      </h6>
                      <span className="info-box-number">
                        {isLoading ? (
                          <Spinner size="sm" animation="border" role="status" />
                        ) : (
                          metrics?.newCustomersThisMonth
                        )}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Staff Performance Section */}
                <div className="col-md-4 col-12">
                  <div className="info-box info-box-hover shadow-lg rounded-lg">
                    <span className="info-box-icon bg-gradient-danger text-white">
                      <i className="fas fa-trophy"></i>
                    </span>
                    <div className="info-box-content">
                      <h6 className="info-box-text">Top Barber</h6>
                      <span className="info-box-number">
                        <span className="info-box-number">
                          {isLoading ? (
                            <Spinner
                              size="sm"
                              animation="border"
                              role="status"
                            />
                          ) : (
                            metrics?.topBarber &&
                            metrics?.topBarberTotalCuts && (
                              <>
                                {metrics.topBarber} (
                                {metrics.topBarberTotalCuts})
                              </>
                            )
                          )}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>

                {/*  */}
              </div>
            </div>

            {/* /.card-body */}
            <div className="card-footer">Dashboard</div>
            {/* /.card-footer*/}
          </div>
          {/* /.card */}
        </section>
        {/* /.content */}
      </div>
      {/* /.content-wrapper */}
    </div>
  );
};

export default Home;
